export default {
  namespaced: true,
  state: {
    isSlideShown: false,
    slideItems: [],
  },
  mutations: {
    SET_IS_SLIDE_SHOWN: (state: any, payload: boolean) => {
      state.isSlideShown = payload
    },
    SET_SLIDE_ITEMS: (state: any, payload: Array<any>) => {
      state.slideItems = payload
    },
  },
  actions: {
    openOrCloseSlider: ({ commit, state }: any) => {
      commit("SET_IS_SLIDE_SHOWN", !state.isSlideShown)
    },
  },
}
